// Copyright @ 2016 itestra GmbH
import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
    selector: "zbd-toggleable",
    template: `
        <div
            class="zas-accordion zas-headline-3"
            [ngClass]="{
                'zas-locked-accordion': isLocked,
                'zas-expanded-accordion': isOpen && !isLocked,
                'zas-collapsed-accordion': !isOpen && !isLocked,
            }"
            (click)="toggleVisibility()"
        >
            <div class="left">
                <span
                    [ngClass]="{
                        'icon-icon-cta-down': isOpen,
                        'icon-icon-cta': !isOpen,
                    }"
                ></span
                >&nbsp;{{ title }}
            </div>
            <div class="right">
                <span
                    class="zbd-validation-indicator"
                    [ngClass]="{
                        'icon-dot-indicator-three zbd-invalid': !sectionIsValid,
                        'icon-hook zbd-valid': sectionIsValid,
                    }"
                ></span>
            </div>
        </div>
        <div *ngIf="isOpen" class="toggleable-content">
            <ng-content></ng-content>
        </div>
    `,
    styles: [
        `
            .toggleable-content {
                padding-left: 20px;
                padding-right: 20px;
            }
        `,
    ],
})
export class ToggleableComponent {
    @Output() opened: EventEmitter<ToggleableComponent> =
        new EventEmitter<ToggleableComponent>();
    @Output() closed: EventEmitter<ToggleableComponent> =
        new EventEmitter<ToggleableComponent>();
    @Input("isValid") sectionIsValid: boolean;
    @Input() title: string;
    @Input() isOpen: boolean;
    @Input() isLocked: boolean;

    constructor() {}

    toggleVisibility(): void {
        if (this.isLocked) {
            return;
        }

        this.isOpen = !this.isOpen;
        if (this.isOpen === true) {
            this.opened.emit(this);
        } else {
            this.closed.emit(this);
        }
    }

    close(): void {
        if (!this.isLocked) {
            this.isOpen = false;
            this.closed.emit(this);
        }
    }

    open(): void {
        if (!this.isLocked) {
            this.isOpen = true;
            this.opened.emit(this);
        }
    }
}
